import { httpRequest } from "@services/http";
import { Debit } from "@models/debit.model";
import { DebitSerializer } from "@models/serializers/debitSerializer";

export interface CreateDebitPayload {
  amount: number;
  effective_date?: string | null;
  reporter?: string | null;
  source_type?: string;
  reason?: string | null;
}

export class CommandCreateDebit {
  async run(contractId: number, payload: CreateDebitPayload): Promise<Debit> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/debits/`;
    const response = await httpRequest<any>(url, {
      method: "POST",
      body: JSON.stringify(payload),
    });
    return DebitSerializer.fromJson(response);
  }
}
